export class TicketModel {
    _id?: string;
    title: string;
    description?: string;
    title_en?: string;
    description_en?: string;
    amount: number;
    discountAmount?: number;
    vatRate?: number;
    hidden?: boolean;
    unlimited?: boolean;
    amountVat10: number;
    amountVat20: number;
    vat10: number;
    vat20: number;
    constructor(data?) {
        data = data || {};
        this._id = data._id || null;
        this.title = data.title || null;
        this.description = data.description || null;
        this.title_en = data.title_en || null;
        this.description_en = data.description_en || null;
        this.amount = data.amount || null;
        this.discountAmount = data.discountAmount || null;
        this.vatRate = data.vatRate || 10;
        this.hidden = data.hidden || false;
        this.unlimited = data.unlimited || false;
        this.amountVat10 = data.amountVat10 || 0;
        this.amountVat20 = data.amountVat20 || 0;
        this.vat10 = data.vat10 || 0;
        this.vat20 = data.vat20 || 0;
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/product/ticket.model.ts